import React, { useState } from 'react';
import { cache } from '../../graphql/cache';
import { useQuery, useMutation } from '@apollo/client';
import {
  GET_SERVICIO_ID,
  GET_SERVICIOS,
  REMOVE_SERVICIO,
} from '../../graphql/actions/servicio';
// nodejs library that concatenates classes
//import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
// @material-ui/icons
import Delete from '@material-ui/icons/Delete';
// core components
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import NavPills from '../../components/UI/NavPills/NavPills';
import Button from '../../components/UI/CustomButtons/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import Notification from '../../components/Notification/Notification';
import ButtonAdd from '../ButtonAdd/ButtonAdd';
import ServicioDel from './ServicioDel';

import sectionDataStyle from '../../assets/jss/coscef/views/servicioSections/sectionDataStyle';

const useStyles = makeStyles(sectionDataStyle);

const ServicioData = (props) => {
  const classes = useStyles();
  const [numServicios, setNumServicios] = useState(30);
  const [field, setField] = useState('createdAt');
  const [order, setOrder] = useState('ASC');
  const [eliminarServicioModal, setEliminarServicioModal] = useState(false);

  const eliminarShowModalHandler = (id) => {
    cache.writeQuery({
      query: GET_SERVICIO_ID,
      data: { getServicioId: id },
    });
    setEliminarServicioModal(true);
  };

  const eliminarCloseModalHandler = () => {
    setEliminarServicioModal(false);
    // ok
    setNumServicios(30);
    setField('createdAt');
    setOrder('ASC');
  };

  const closeModalHandler = (data) => {
    //console.log(data);
    if (data.removeServicio) setEliminarServicioModal(false);
    else console.log('Error eliminando servicio.');
  };

  const updateCacheDel = (cache, id) => {
    const { getServicios } = cache.readQuery({
      query: GET_SERVICIOS,
      variables: {
        paginate: {
          numServicios: numServicios,
          cursor: '',
          sortBy: { field: field, order: order },
        },
      },
    });

    const nuevoServicios = getServicios.servicios.filter(
      (servicio) => servicio.id !== id
    );

    if (getServicios && nuevoServicios) {
      cache.writeQuery({
        query: GET_SERVICIOS,
        variables: {
          paginate: {
            numServicios: numServicios,
            cursor: '',
            sortBy: { field: field, order: order },
          },
        },
        data: {
          getServicios: {
            servicios: nuevoServicios,
          },
        },
      });
    }
  };

  const {
    loading: loadingServicios,
    error: errorServicios,
    data: dataServicios,
  } = useQuery(GET_SERVICIOS, {
    variables: {
      paginate: {
        numServicios: numServicios,
        cursor: '',
        sortBy: { field: field, order: order },
      },
    },
    errorPolicy: 'all',
  });

  const [
    eliminarServicio,
    { loading: loadingRemove, error: errorRemove, data: dataRemove },
  ] = useMutation(REMOVE_SERVICIO, {
    errorPolicy: 'all',
    update: updateCacheDel,
    onCompleted: (data) => closeModalHandler(data),
  });

  const removeServicioHandler = (id) => {
    eliminarServicio({
      variables: {
        input: {
          id: id,
        },
      },
    });
  };

  let showNotification = null;
  let seccionComentario = null;
  let seccionTitulo = null;
  let seccionNavServicio = null;
  let seccionBotonAdd = null;
  let removeModal = (
    <ServicioDel
      show={eliminarServicioModal}
      close={eliminarCloseModalHandler}
      removeServicio={removeServicioHandler}
    />
  );

  if (loadingServicios) {
    seccionComentario = null;

    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (loadingRemove) removeModal = <Spinner color='gray' />;

  if (errorServicios) {
    seccionComentario = null;

    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title + ' ' + classes.textCenter}>
              Error al buscar los servicios en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionNavServicio = null;
    seccionBotonAdd = null;

    showNotification = errorServicios.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorServicios ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorRemove) {
    showNotification = errorRemove.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorRemove ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataServicios && dataServicios.getServicios) {
    const { getServicios } = dataServicios;
    //console.log(getServicios);
    if (getServicios.servicios.length === 0) {
      seccionComentario = null;

      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title + ' ' + classes.textCenter}>
                No se encontraron servicios, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionNavServicio = null;

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'servicio'} />
        </div>
      ) : null;
    } else {
      seccionComentario = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h5 className={classes.description}>
                La oferta de servicios se prestarán exclusivamente al sector
                privado, incluye cuenta propitas, Mipymes, Cooperativas y
                personas naturales.
              </h5>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionTitulo = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title}>Cartera de Servicios</h2>
            </GridItem>
          </GridContainer>
        </div>
      );

      seccionNavServicio = (
        <div className={classes.profileTabs}>
          {getServicios.servicios.map((servicio) => (
            <NavPills
              key={servicio.node._id}
              alignCenter
              horizontal={{
                tabsGrid: { xs: 12, sm: 3, md: 4 },
                contentGrid: { xs: 12, sm: 9, md: 8 },
              }}
              color='dark'
              tabs={[
                {
                  tabButton: servicio.node.titulo,
                  tabContent: (
                    <div className={classes.marginTop10}>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: servicio.node.contenido,
                        }}
                      />
                      {props.isAuth ? (
                        <div className={classes.textCenter}>
                          <Button
                            round
                            justIcon
                            color='white'
                            onClick={(e) => {
                              e.preventDefault();
                              props.history.push(
                                '/editar-servicio/' + servicio.node._id
                              );
                            }}
                          >
                            <Icon>mode_edit</Icon>
                          </Button>
                          <Button
                            round
                            justIcon
                            color='white'
                            onClick={() =>
                              eliminarShowModalHandler(servicio.node._id)
                            }
                          >
                            <Delete />
                          </Button>
                        </div>
                      ) : null}
                    </div>
                  ),
                },
              ]}
            />
          ))}
        </div>
      );

      seccionBotonAdd = props.isAuth ? (
        <div id='buttonadd'>
          <ButtonAdd nombreComponente={'servicio'} />
        </div>
      ) : null;
    }
  }
  if (dataRemove && dataRemove.removeServicio) {
    const { removeServicio } = dataRemove;
    if (removeServicio.success && removeServicio.code === '200') {
      showNotification = (
        <Notification
          key={removeServicio.code}
          mostrar={removeServicio.success ? true : false}
          msg={removeServicio.message}
          stt={removeServicio.success}
        />
      );
    }
  }

  return (
    <div className={classes.sections}>
      <div className={classes.sectionWhite}>
        <div>
          <div className={classes.container}>
            {seccionComentario}
            {seccionTitulo}
            <div className={classes.marginTop35}>
              {removeModal}
              {seccionNavServicio}
              {seccionBotonAdd}
            </div>
          </div>
          {showNotification}
        </div>
      </div>
    </div>
  );
};

export default withRouter(ServicioData);
